import instance from './instance'

const dealerSchemeUrl = 'modules-coupon/dealer-schemes'

export const getDealerSchemeList = (page: number, pageSize: number, filterKey: any) =>
  instance.get(`${dealerSchemeUrl}?page=${page}&pageSize=${pageSize}&filterkey=${filterKey}`)

export const getDealerSchemeById = (id: number) => instance.get(`${dealerSchemeUrl}/${id}`)

export const createDealerScheme = (payload: any) => instance.post(dealerSchemeUrl, payload)

export const updateDealerScheme = (id: number, payload: any) =>
  instance.post(`${dealerSchemeUrl}/${id}`, payload)

export const deleteDealerScheme = async (id: number) => await instance.delete(`${dealerSchemeUrl}/${id}`)

